import { Theme } from '@mui/material/styles'
import { contentFullHeight, palette } from 'c1ui'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    backLink: {
        m: (theme: Theme): string => theme.spacing(3, 0, 1, 0),
    },
    outcomeIcon: {
        fontSize: 16,
        display: 'block',
    },
    icon: {
        background: 'transparent',
        '&:hover': {
            background: 'transparent',
        },
    },
    approved: {
        color: palette.success.main,
    },
    denied: {
        color: palette.error.main,
    },
    purple: {
        color: palette.primary.main,
    },
    loadingIcon: {
        color: palette.text.secondary,
    },
    row: {
        height: '42px',
    },
    revoked: {
        color: palette.error.main,
    },
    error: {
        color: palette.error.main,
    },
    pending: {
        color: palette.text.secondary,
    },
    cancelled: {
        color: palette.text.secondary,
    },
    deleted: {
        color: palette.text.secondary,
    },
}

export const TaskStatus: moduleStyleType = {
    container: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    approved: {
        color: 'success.main',
    },
    denied: {
        color: 'error.main',
    },
    closed: {
        color: 'text.secondary',
    },
    deleted: {
        color: 'text.secondary',
    },
    reassigned: {
        color: 'primary.main',
    },
    provisioned: {
        color: 'primary.main',
    },
    icon: {
        fontSize: 16,
    },
    layout: { display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 0 },
}

export const TasksStyle: moduleStyleType = {
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
    },
    viewLink: {
        marginLeft: 1,
    },
    bulkActionButton: {
        marginRight: 1,
    },
    insights: {
        backgroundColor: palette.background.default,
        padding: 1,
        paddingLeft: '7px',
        paddingRight: '7px',
        borderRadius: '20px',
        fontSize: '14px',
        border: `1px solid ${palette.border.subtle}`,
    },
    insightsFlag: {
        fontSize: '16px',
        color: 'icons.gold',
    },
}

export const BulkActionsApproveProgress: moduleStyleType = {
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        marginTop: 2,
    },
    item: {
        marginRight: 2,
    },
    text: {
        color: 'text.secondary',
    },
    icon: {
        fontSize: 14,
        color: 'text.secondary',
    },
    iconContainer: {
        display: 'flex',
        marginRight: 1,
    },
}

export const TaskPageStyles: moduleStyleType = {
    container: { display: 'flex', height: contentFullHeight, flexDirection: 'column' },
    content: { overflow: 'auto' },
}

export const TaskListWithSidebarStyles = {
    sidebarItemButton: {
        width: '100%',
        px: 2,
        py: 1,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'transparent',
        '&.Mui-selected': {
            border: '1px solid',
            borderColor: 'primary.light',
        },
    },
    sidebarList: { width: '100%' },
    sidebarItem: {
        width: '250px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    sidebarAppItemContainer: { px: 1 },
    sidebarAppItem: { width: '100%', my: 1 },
    sidebarAppDisplay: { ml: 2, mt: 1, mb: 0, color: 'grey.2' },
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        overflow: 'hidden',
    },
    sidebar: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'auto',
        maxWidth: '320px',
        minWidth: '320px',
        border: '1px solid',
        borderColor: 'border.primary',
        borderRadius: C1BorderRadius.large,
    },
    content: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'auto',
    },
    appDetails: {
        border: '1px solid',
        borderRadius: C1BorderRadius.large,
        borderColor: 'border.primary',
        p: 2,
    },
    appDetailKey: { width: '100px' },
}
